export default {
  'ALLOCATION' (state) {
    return state.allocation
  },
  'ALLOCATIONS' (state) {
    return state.allocations
  }
}
